import "./style/footer.css";

export const Footer = () =>{
  return(
    <footer>
      <p>&copy; 2025 秋羽クラブ ホームページ。すべての権利を保有します。</p>
    </footer>
  );
}
